<template>
  <div class="cb-error-page">
    <div class="cb-error-page__container">
      <img
        alt="Exclamation Point Icon"
        class="cb-error-page__container__icon"
        src="../assets/icons/exclamation-point-blue.svg"
      />
      <div class="cb-error-page__container__content">
        <h1 class="cb-heading-5" tabindex="-1" ref="title">
          Oops, that didn't go as expected. Please go to
          <a href="https://www.myadt.com/" class="cb-link">MyADT.com</a> and try
          again.
        </h1>
        <div class="cb-error-page__container__content__divider"></div>
        <a
          @click.prevent="handleNavigate"
          class="cb-button cb-button--blue"
          href="https://www.myadt.com/"
          >Go to MyADT</a
        >
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
export default {
  mounted() {
    this.$refs.title.focus();
    document.title = "CellBridge - Oops, that didn't go as expected. Please go to MyADT.com and try again.";
  },
  methods: {
    handleNavigate() {
      gtag('event', 'navigateClick', {
        event_label: 'go to myadt',
        event_category: 'errorPage',
        value: 1,
      });
      window.location.href = 'https://www.myadt.com/';
    },
  },
};
</script>

<style lang="scss" scoped>
.cb-error-page {
  background-color: $light-grey;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 20px 20px 40px;

  &__container {
    background-color: white;
    padding: 60px 20px 28px;
    border-radius: 10px;
    max-width: 562px;
    box-sizing: border-box;
    margin: 0 auto;
    text-align: center;

    &__icon {
      margin: 0 auto 12px;
      height: 54px;
      width: 13px;
    }

    &__content {
      .cb-heading-5 {
        margin-bottom: 12px;
      }

      .cb-button {
        margin-top: 20px;
        width: 100%;
      }
    }
  }

  @include desktop {
    display: flex;
    min-height: 100vh;
    justify-content: center;
    align-items: center;
    background-color: unset;
    padding: 20px;
    box-sizing: border-box;

    &__container {
      display: flex;
      flex-direction: column;
      width: 682px;
      margin: 0;
      max-width: 682px;
      box-sizing: border-box;
      padding: 100px 52px 28px;

      &__content {
        .cb-heading-5 {
          padding: 0 74px;
          font-size: 28px;
          line-height: 38px;
          margin-bottom: 40px;
        }

        &__divider {
          height: 1px;
          margin: 0 0 40px;
          background-color: $light-grey;
        }

        .cb-button {
          margin: 0;
          width: auto;
        }
      }
    }
  }
}
</style>
